import { RouteConfig } from 'vue-router';

export function procedureDescriptionRoute(name: string): RouteConfig {
  return {
    path: 'description',
    name,
    component: () =>
      import(/* webpackChunkName: "ProcedureData" */ '@/views/mainRoute/procedure/steps/Description.vue'),
    meta: {}
  };
}
